import { Card, CardContent, Typography } from "@mui/material"
import classNames from "classnames"
import Markdown from "markdown-to-jsx"
import PropTypes from "prop-types"
import { useState } from "react"
import ExternalLinks from "components/link"
import { SOLUTION } from "../shapes"
import "./style.scss"

function Solution({ solution }) {
  const [expanded, setExpanded] = useState(false)
  const toggleExpanded = () => setExpanded(!expanded)

  return (
    <Card
      square
      className={classNames("solution", { condensed: !expanded, expanded })}
      onClick={toggleExpanded}
    >
      <div className="title">
        <Typography variant="h5" component="h5" className="description">{solution.title}</Typography>
      </div>
      <CardContent className="text-content">
        <ExternalLinks>
          <Markdown>{solution.content}</Markdown>
        </ExternalLinks>
      </CardContent>
    </Card>
  )
}

Solution.propTypes = {
  solution: SOLUTION.isRequired,
  openEditDialog: PropTypes.func.isRequired,
  openDeleteDialog: PropTypes.func.isRequired,
}

export default Solution
